import * as THREE from "three";
import gsap from "gsap";
import { OBJLoader2 } from "three/examples/jsm/loaders/OBJLoader2";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import antonfont from "./font/Anton_Regular.json";
import fallingmodel from "./models/manfalling2.obj";

import fragment from "./shaders/fragment.glsl";
import vertex from "./shaders/vertex.glsl";
//import * as dat from "dat.gui";
//let OrbitalControls = require("three-orbit-controls")(THREE);

export default class Sketch {
  constructor(options) {
    this.scene = new THREE.Scene();
    this.container = options.dom;
    // this.music = options.music;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
    });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0x000000, 1);
    //this.renderer.setClearColor(0xeeeeee, 1);
    //this.renderer.physicallyCorrectLights = true;
    this.renderer.outputEncoding = THREE.sRGBEncoding;

    this.container.appendChild(this.renderer.domElement);
    this.camera = new THREE.PerspectiveCamera(
      70,
      window.innerWidth / window.innerHeight,
      0.001,
      1000
    );

    this.camera.position.set(0, 0, 3);
    //this.controls = new OrbitalControls(this.camera, this.renderer.domElement);
    this.time = 0;
    this.isPlaying = true;

    this.fontLoader = new THREE.FontLoader();
    this.modelloader = new OBJLoader2();
    this.addTexts();
    this.addLights();
    this.addMan();
    this.addBars();
    this.addPostProcessing();
    this.resize();
    this.render();
    this.setupResize();
   // this.startAnimations();
  }
  settings() {
    let that = this;
    this.settings = {
      progress: 0,
    };
    //this.gui = new dat.GUI();
    //this.gui.add(this.settings, "progress", 0, 1, 0.01);
  }
  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }
  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
  }
  addPostProcessing() {
    this.composer = new EffectComposer(this.renderer);
    this.composer.addPass(new RenderPass(this.scene, this.camera));
    const params = {
      exposure: 0.5,
      bloomStrength: 0.4,
      bloomThreshold: 0,
      bloomRadius: 0,
    };
    const bloomPass = new UnrealBloomPass(
      new THREE.Vector2(window.innerWidth, window.innerHeight),
      1.5,
      0.1,
      0.85
    );
    bloomPass.threshold = params.bloomThreshold;
    bloomPass.strength = params.bloomStrength;
    bloomPass.radius = params.bloomRadius;
    this.composer.addPass(bloomPass);
  }
  addBars() {
    let that = this;
    const n = 16;
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable",
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { type: "f", value: 0 },
        texture1: { type: "t", value: null },
        resolution: { type: "v4", value: new THREE.Vector4() },
        uvRate1: {
          value: new THREE.Vector2(1, 1),
        },
      },
      transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment,
    });
    //this.geometry = new THREE.PlaneGeometry(1, 3, 1, 1);
    //this.plane = new THREE.Mesh(this.geometry, this.material);
    this.bars = [];
    let s = 0.5;
    for (let i = 0; i < n; i++) {
      let h = 1 + Math.random() * 3;
      if (i == n / 2) {
        h = 1;
      }
      let geometry = new THREE.BoxGeometry(1, h, 0.05);
      let mesh = new THREE.Mesh(geometry, this.material);
      //mesh.position.x = -n / 5 + (i + 0.001 * i-1);
      mesh.position.x = (-n / 2 + i) * 0.65;
      mesh.position.y = -2;
      mesh.position.z = -0.5;
      mesh.scale.set(s, s, s);
      this.bars.push(mesh);
      this.scene.add(mesh);
    }
    // this.scene.add(this.plane);
  }
  addMan() {
    let that = this;

    this.modelloader.load(
      fallingmodel,
      function (obj) {
        //console.log(obj);
        obj.rotation.y = Math.PI;
        //obj.rotation.z = -Math.PI / 4;
        let s = 0.1;
        obj.position.y = 2.3;
        obj.position.z = 0.1;
        obj.scale.set(s, s, s);
        //this.man = obj;
        // gsap.to(obj.position, 120, { y: -2.5 });
        that.scene.add(obj);
        
        document.getElementById("loading").style.display = "none";
        document.getElementById("explore").style.display = "flex";
        document.getElementById("explore").addEventListener("click", () => {
          document.getElementById("loader").style.display = "none";          
          gsap.to(obj.position, 120, { y: -2.5 });          
          that.startAnimations(); 
          console.log("clicked");
        });
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
  }
  addLights() {
    const light = new THREE.PointLight(0xffffff, 0.9, 13);
    const p = 10;
    light.position.set(0, 0, p);
    this.scene.add(light);
    const lightback = new THREE.PointLight(0xffffff, 0.6, 10);
    lightback.position.set(0, 0, -2);
    this.scene.add(lightback);
    const amblight = new THREE.AmbientLight(0x000000); // soft white light
    this.scene.add(amblight);
    const directionalLight = new THREE.DirectionalLight(0x166e00, 1);
    this.scene.add(directionalLight);
  }
  addTexts() {
    let that = this;
    const font = this.fontLoader.parse(antonfont);
    //console.log(font);
    const firstLineGeometry = new THREE.TextGeometry("SCAM 1992", {
      font: font,
      size: 40,
      height: 0.01,
      curveSegments: 16,
      bevelEnabled: true,
      bevelThickness: 5,
      bevelSize: 1,
      bevelOffset: 0,
      bevelSegments: 5,
    });
    const secondLineGeometry = new THREE.TextGeometry(
      "THE HARSHAD MEHTA STORY",
      {
        font: font,
        size: 40,
        height: 0.01,
        curveSegments: 8,
        bevelEnabled: true,
        bevelThickness: 5,
        bevelSize: 1,
        bevelOffset: 0,
        bevelSegments: 5,
      }
    );
    // Setup a material
    const firstmaterial = new THREE.MeshPhongMaterial({
      color: "white",
      // wireframe: true,
    });
    const secondmaterial = new THREE.MeshPhongMaterial({
      color: "green",
      // wireframe: true,
    });
    this.firstmesh = new THREE.Mesh(firstLineGeometry, firstmaterial);
    let s1 = 0.02;
    let s2 = 0.0085;
    let posX = -2.5;
    let posY = -0.5;
    if (this.width < 600) {
      s1 = 0.0095;
      s2 = 0.004;
      posX = -1.1;
      posY = -0.3;
    }
    this.firstmesh.scale.set(s1, s1, s1);
    //firstmesh.rotation.y = Math.PI;
    this.firstmesh.position.x = posX;
    this.scene.add(this.firstmesh);
    this.secondmesh = new THREE.Mesh(secondLineGeometry, secondmaterial);
    this.secondmesh.scale.set(s2, s2, s2);
    //secondmesh.rotation.y = Math.PI;
    this.secondmesh.position.x = posX;
    this.secondmesh.position.y = posY;
    this.scene.add(this.secondmesh);
    //this.music.play();
    this.firstmesh.position.z = 4;
    this.secondmesh.position.z = 4;

    // TimelineMax.to(this.firstmesh.position,2, {z: 4});
  }
  stop() {
    this.isPlaying = false;
  }
  play() {
    if (!this.isPlaying) {
      this.render();
      this.isPlaying = true;
    }
  }
  startAnimations() {
    let that = this;
    document.getElementById("audio").play();
    setTimeout(() => {
      gsap.to(that.firstmesh.position, 3, { z: 0 });
      gsap.to(that.secondmesh.position, 3, { z: 0 });
      document.getElementById("watch").style.display = "flex";
      gsap.from(".watch", 1, { y: 200, delay: 1 });
    }, 2000);
  }
  render() {
    if (!this.isPlaying) return;
    this.time += 0.05;
    this.bars.forEach((bar) => {
      bar.scale.y = 1 + 0.01 * this.time;
    });
    requestAnimationFrame(this.render.bind(this));
    //this.renderer.render(this.scene, this.camera);
    this.composer.render();
  }
}
